<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">    
    <!--<feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />-->
    <span class="feather-icon select-none relative switch-publish mr-4">
      <vs-switch v-model="params.data.Approved">
        <span slot="true">Approve</span>
        <span slot="false">UnApprove</span>
      </vs-switch>
    </span>

    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord()"
    />
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  watch: {
    "params.data.Approved"() {
      this.$vs.loading();
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("qnaManagement/updateStatusApproved", {
          id: this.params.id,
          SessionId: this.params.SessionId,
          Approved: this.params.data.Approved
        })
        .then(() => {
          this.$vs.loading.close();
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  methods: {
    editRecord() {
      this.$vs.loading();
      this.$store.dispatch("qnaManagement/fetchSingleQnA", {id: this.params.id, SessionId: this.params.SessionId,}).then(res => {  
        this.$vs.loading.close();
        this.$root.$emit("openQuestionPopUp", res);
      })
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: params.data.Approved ? "Approved successfully" : "Unapproved successfully"
      });
    }
  }
};
</script>
